module.exports = __webpack_public_path__ + "media/images/icons/outlined/clear-fa46ae2af7c93a639c78fb7589654be8.svg";